<template>

    <div>

        <header id="H" class="register">

            <router-link to="/login">
                <img src="/static/img/app/logom.png?v=1.0" class="logo" />
            </router-link>

            <div class="table">
                <div class="cell">
                      <h1>Marta Roggiero</h1>
                      <p>Creá tu cuenta de Marga Roggerio para<br> usuarios mayoristas.</p>
                </div>
            </div>

        </header>

        <section class="register">
          <div class="container">
            <div class="panel">
              <form method="post" @submit.prevent="registerForm" lang="es">

                <div class="box-title">
                  <h1>Registrarme</h1>
                  <p>
                      Completa el siguiente formulario con los datos de facturación de tu empresa o emprendimiento para comenzar.
                  </p>
                </div>

                <div class="row">


                  <div class="col-md-6 col-xs-12">
                    <input class="required" v-model="cuit" type="text" placeholder="CUIT o DNI *"  />
                  </div>


                </div>

                <br>
                <br>

                <div class="box-title">
                  <h1>Datos de acceso</h1>
                  <p>
                      Con los siguientes datos podrás loguearte en la tienda.
                  </p>
                </div>

                <div class="row">

                  <!-- -->
                  <div class="col-md-6">
                    <input class="required" v-model="email" type="text" placeholder="Email *"  />
                  </div>

                  <div class="col-md-3">
                    <input class="required" v-model="password" type="password"  placeholder="Contraseña *"  />
                  </div>

                  <div class="col-md-3">
                    <input class="required" v-model="password_repeat" type="password" placeholder="Repetir contraseña *"  />
                  </div>

                  <div class="col-lg-12">
                    <br>
                    <input type="submit" class="submit btn-submit"  value="REGISTRARME">
                  </div>

                </div>

                <ul class="login-links">
                  <li>
                      <router-link to="login">&bull; Ya estoy registrado. Loguearme.</router-link>
                  </li>
                  <li>
                      <!--<a href="https://p/forgot">&bull; Olvidé mi contraseña.</a>-->
                  </li>
                </ul>


              </form>

            </div>
          </div>
        </section>

    </div>

</template>

<script>
  import Api from '@/Api'

    export default {
      name: "RegisterPage",
      mounted(){
          $('body').removeClass();
      },
      data: function () {
        return {
          error:'',
          pending:false,
          nombre:'',
          cuit:'',
          calle:'',
          numero:'',
          piso:'',
          depto:'',
          localidad:'',
          provincia_id:'',
          email:'',
          password:'',
          password_repeat:'',
          provincias:[]
        };
      },
      methods:{
        registerForm(){

          this.error = "";
          this.pending = true;

          this.$store.dispatch('register', this)
            .then((response) => {
              this.pending = false;
              alert("ya se pidio el registro, una vez que este habilitado sera notificado");
              this.$router.push({name: 'Home'});
            })
            .catch(err => {
              this.pending = false;
              this.error = err;
                this.$swal({
                  title: 'Error',
                  text: err,
                  type: 'warning',
                }).then((result) => {

                });
            });
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RegisterPage.vue